class SnackbarActionType {
    static addSnackbar = 'APP_SNACKBAR_ADD';
    static removeSnackbar = 'APP_SNACKBAR_REMOVE';
}

export default SnackbarActionType;
